"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ViewElementBranchResolver = /** @class */ (function () {
    function ViewElementBranchResolver() {
    }
    /**
     * Returns branch index of column element
     * @param {ColumnView} columnView
     * @param columnRoot
     * @returns {number}
     */
    ViewElementBranchResolver.getColumnElementBranchIndex = function (columnView) {
        var firstLevelParent = columnView;
        while (firstLevelParent.parent != null) {
            firstLevelParent = firstLevelParent.parent;
        }
        var found = false;
        var branchIndex = 0;
        (function traverse(currentColumnView, targetColumnView) {
            if (!found) {
                if (currentColumnView === targetColumnView) {
                    found = true;
                    return;
                }
                var children = currentColumnView.children;
                if (children.length === 0) {
                    branchIndex++;
                }
                else {
                    for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
                        var child = children_1[_i];
                        traverse(child, targetColumnView);
                    }
                }
            }
        })(firstLevelParent, columnView);
        return branchIndex;
    };
    ViewElementBranchResolver.getRowElementBranchIndex = function (rowView, rowsRootView) {
        var found = false;
        var branchIndex = 0;
        var firstLevelRows = rowsRootView.rows;
        for (var _i = 0, firstLevelRows_1 = firstLevelRows; _i < firstLevelRows_1.length; _i++) {
            var row = firstLevelRows_1[_i];
            if (!found) {
                (function traverse(currentRowView, targetRowView) {
                    if (!found) {
                        if (currentRowView === targetRowView) {
                            found = true;
                            return;
                        }
                        var children = currentRowView.children;
                        if (children.length === 0) {
                            branchIndex++;
                        }
                        else {
                            for (var _i = 0, children_2 = children; _i < children_2.length; _i++) {
                                var child = children_2[_i];
                                traverse(child, targetRowView);
                            }
                        }
                    }
                })(row, rowView);
            }
        }
        return branchIndex;
    };
    return ViewElementBranchResolver;
}());
exports.ViewElementBranchResolver = ViewElementBranchResolver;
//# sourceMappingURL=view-element-branch-resolver.js.map